import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import "./Gallery.css";
import image1 from '../asset/Images/z1.png'
import image2 from '../asset/Images/z5.png'
import image3 from '../asset/Images/z3.png'
import image4 from '../asset/Images/z4.png'
const images = [
  image1,
  image2,
  image3,
  image4,

 
];

const Gallery = () => {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,   // Hide navigation arrows
    dots: false,     // Hide dots
    autoplay: true,  // Auto-sliding images
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024, // Tablets & smaller screens
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768, // Mobile
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="gallery mt-2">
      <Slider {...settings}>
        {images.map((img, index) => (
          <div key={index} className="gallery-item">
            <img src={img} alt={`Gallery ${index}`} />
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default Gallery;
